import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Alert } from '../../../components/atoms'
import { LoadingView } from '../../../../common/components/atoms';

import { ERROR_MESSAGE } from '../../../common/constants.js';
import { USERTYPE } from '../../../common/constants.js';
import { validationPassword } from '../../../../common/helper/validation.js';

import logo from '../../../components/atoms/data/logo.png'

class SettingPassword extends Component {
    constructor(props) {
        super(props);

        this.refAlert = React.createRef();
        this.state = {
            password: "",
            confirm: "",
            displayAlert: false,
            errorMessage: "",
        }
    }
    componentDidMount() {
        this.props.dispatch({
            type: "CheckMaintenance_Saga"
        });
    }
    onSuccess = () => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        if(this.props.user.type === USERTYPE.ADMIN){
            this.props.history.push('/admin/top');
        } else if(this.props.user.type === USERTYPE.TRAINER){
            this.props.history.push('/admin/trainer/top');
        } else {
            this.props.history.push('/home');
        }
    }
    onFailure = (status, error) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.setState({ 
            displayAlert: false,
        });
    }

    onClickChangePassword = (e) => {
        if (this.state.password === "") {
            this.refAlert.current.setAlertAnime();
            this.setState({ 
                displayAlert: true,
                errorMessage: "パスワード" + ERROR_MESSAGE["not_entered"],
            });
        } else if (this.state.password !== this.state.confirm) {
            this.refAlert.current.setAlertAnime();
            this.setState({ 
                displayAlert: true,
                errorMessage: ERROR_MESSAGE["discrepancy_password"],
            });
        } else {
            if(validationPassword(this.state.password)) {
                this.props.dispatch({
                    type: "LoadStart"
                });
                this.props.dispatch({
                    type: 'SettingPassword_Saga',
                    id: this.props.user.id,
                    password: this.state.password,
                    onSuccess: this.onSuccess,
                    onFailure: this.onFailure,
                });
            } else {
                this.refAlert.current.setAlertAnime();
                this.setState({ 
                    displayAlert: true,
                    errorMessage: ERROR_MESSAGE["invalid_password"],
                });
            }
        }
    }

    onClickBack = (e) => {
        this.props.history.goBack();
    }

    onChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        })
    }

    render() {
        const propAlert = {
            display: this.state.displayAlert,
            message: this.state.errorMessage,
        }
        return (
            <Body>
                <Logo src={logo} />
                パスワードを設定してください。
                <Input>
                    <input type="password" name="password" value={this.state.password} placeholder="パスワード"
                        onChange={this.onChange}></input>
                </Input>
                <Input>
                    <input type="password" name="confirm" value={this.state.confirm} placeholder="確認用"
                        onChange={this.onChange}></input>
                </Input>
                <Alert ref={this.refAlert} {...propAlert} />
                <Buttons>
                    <Button Color="#0077FF" onClick={this.onClickChangePassword}>
                        パスワード変更
                    </Button>
                    <Button Color="#707070" onClick={this.onClickBack}>
                        戻る
                    </Button>
                </Buttons>
                <LoadingView Display={this.props.loading} />
            </Body>
        );
    }
}

const mapStateToProps = store => {
    return {
        user: store.login.user,
        address: store.login.address,
        loading: store.loading.loading,
    }
};

const connectedSettingPassword = connect(mapStateToProps)(SettingPassword);
export { connectedSettingPassword as SettingPassword };

const Body = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 32px 0;
`;

const Logo = styled.img`
    width: 208px;
    height: 32px;
    margin-bottom: 32px;
`;
const Input = styled.div`
    width: 100%;
    max-width: 320px;
    text-align: center;
    margin: 20px 0;
    font-size: 20px;
    input {
        width: 80%;
        font-size: 20px;
        padding: 10px 20px;
    }
`;

const Buttons = styled.div`
    position: fixed;
    bottom: 32px;
    left: 50%;
    transform: translateX(-50%);
    width: 80%;
    max-width: 258px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;
const Button = styled.div`
    font-size: 20px;
    padding: 10px 20px;
    background-color: ${props => (props.Color)};
    color: #fff;
    border-radius: 50px;
    width: 80%;
    text-align: center;
    :nth-of-type(n+2) {
        margin-top: 10px;
    }
`;
